import { useState } from 'react';
import { PropTypes } from 'prop-types';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { InfoPopover } from 'components/UI/InfoPopover/InfoPopover';
import { ReactComponent as HelpIcon } from 'assets/icons/svgs/icon-help.svg';
import useWindowDimensions from 'hooks/use-window-dimensions';

import './PaymentPersonalDetails.scss';

export const PaymentPersonalDetails = (props) => {
  const {
    DataCollectionText,
    PresenterText,
    AsiaTopaPresenterText,
    subscribeCheckboxHandler,
    subscribeCheckboxChecked,
    subscribeAsiaCheckboxHandler,
    subscribeEmailCheckboxHandler,
    subscribeEmailCheckboxChecked,
  } = props;
  const [openPopup, setOpenPopup] = useState(false);
  const { isMobile } = useWindowDimensions();
  const popupHintClass = isMobile ? 'hint-visible-m' : 'hint-visible-d';
  const popupOpenClass = openPopup === 'inputPostcode' ? popupHintClass : '';
  const postcodePopupClasses = ['form-hint', popupOpenClass].join(' ');

  const showPopupHandler = (inputId) => {
    setOpenPopup(inputId);
  };

  const showPopupMobileHandler = (inputId) => {
    setOpenPopup((prevState) => (prevState ? false : inputId));
  };

  return (
    <div className="cart-user-details">
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <h3 className="h4">Your details</h3>
            <p>Important: For your security and to ensure your tickets are not subject to fraud</p>
          </div>
        </div>
        <div className="form-user-details">
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="form-group">
                <InputControlled id="inputPhone" labelText="Phone number" ariaRequired />
              </div>
              <div className="form-group form-group-postcode">
                <InputControlled
                  id="inputPostcode"
                  labelText="Postcode"
                  showPopupHandler={showPopupHandler}
                  ariaRequired
                />
                <button
                  type="button"
                  className="hint-btn visible-xs"
                  onClick={() => showPopupMobileHandler('inputPostcode')}
                >
                  <HelpIcon className="payment-details__help-icon" />
                </button>
                <div className={postcodePopupClasses}>
                  <p>
                    If you have an international postcode that is not accepted, please enter 0000.
                  </p>
                </div>
              </div>
              <InfoPopover
                infoContent={DataCollectionText}
                infoLinkLabel="Why do I need to give this information?"
                displayLabelOnMobile
                extendClass="details-info-popover"
              />
            </div>
          </div>
        
          <div className="callout-container bg-light-blue cart-subscription">
            <h3 className="h6">Hear more from Arts Centre Melbourne?</h3>
            <div className="custom-checkbox checkbox-lg">
              <input
                id="checkboxSubscribeOptIn"
                type="checkbox"
                onChange={subscribeEmailCheckboxHandler}
                checked={subscribeEmailCheckboxChecked}
              />
              <label htmlFor="checkboxSubscribeOptIn">
                Yes, I would like to hear more about future events and offers from Arts Centre Melbourne.
              </label>
            </div>
          </div>
         
          {PresenterText && (
            <div className="callout-container bg-light-blue cart-subscription">
              <h3 className="h6">Hear more from {PresenterText}?</h3>
              <div className="custom-checkbox checkbox-lg">
                <input
                  id="checkboxSubscribeOther"
                  type="checkbox"
                  onChange={subscribeCheckboxHandler}
                  checked={subscribeCheckboxChecked}
                />
                <label htmlFor="checkboxSubscribeOther">
                  Yes, I would like to hear more about future events and offers from {PresenterText}{' '}
                  so please provide them with my details.
                </label>
              </div>
            </div>
          )}
          {AsiaTopaPresenterText && (
            <div className="callout-container bg-light-blue cart-subscription">
              <h3 className="h6">Hear more from Asia Topa?</h3>
              <div className="custom-checkbox checkbox-lg">
                <input
                  id="checkboxSubscribeAsiaTopa"
                  type="checkbox"
                  onChange={subscribeAsiaCheckboxHandler}
                />
                <label htmlFor="checkboxSubscribeAsiaTopa">
                  Yes, I would like to hear more about future events and offers from Asia TOPA.
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

PaymentPersonalDetails.propTypes = {
  DataCollectionText: PropTypes.string,
  PresenterText: PropTypes.string,
  AsiaTopaPresenterText: PropTypes.string,
  subscribeCheckboxHandler: PropTypes.func,
  subscribeCheckboxChecked: PropTypes.bool,
  subscribeAsiaCheckboxHandler: PropTypes.func,
  subscribeEmailCheckboxHandler: PropTypes.func,
  subscribeEmailCheckboxChecked: PropTypes.bool,
};
